import { useState } from 'react';

const MarketplaceCard = ({ name, subtitle, tooltip }) => {
  const [hovered, setHovered] = useState(false);
  return (
    <div
      className="bg-[#F4F1EA] p-6 rounded shadow-lg transform hover:-translate-y-2 transition-transform cursor-pointer group relative"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <div className={`absolute -top-3 left-1/2 -translate-x-1/2 bg-[#1F1F1F] text-white text-[10px] font-typewriter px-2 py-0.5 rounded transition-opacity ${hovered ? 'opacity-100' : 'opacity-0'}`}>{tooltip}</div>
      <h4 className="font-serif-display text-2xl mb-1">{name}</h4>
      <p className="text-xs font-typewriter opacity-50">{subtitle}</p>
      <div className="mt-4 flex justify-end">
        <i className="ph-bold ph-download-simple"></i>
      </div>
    </div>
  );
};

const DownloadSection = () => {
  return (
    <section className="py-24 bg-[#b7eb6f] text-[#1F1F1F]">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="font-serif-display text-5xl text-center mb-16">Скачивайте под любой маркетплейс</h2>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          <MarketplaceCard name="Wildberries" subtitle="Вертикальный" tooltip="900x1200" />
          <MarketplaceCard name="Ozon" subtitle="Квадрат" tooltip="1200x1200" />
          <MarketplaceCard name="Яндекс" subtitle="Маркет" tooltip="Square" />
          <MarketplaceCard name="Amazon" subtitle="Универсальный" tooltip="Global" />
        </div>
        <div className="flex justify-center mt-12 gap-4 text-xs font-typewriter uppercase tracking-widest">
          <span className="flex items-center gap-2"><i className="ph-fill ph-archive"></i> Архив</span>
          <span className="flex items-center gap-2"><i className="ph-fill ph-file-image"></i> PNG/JPG</span>
          <span className="flex items-center gap-2"><i className="ph-fill ph-layers"></i> По слоям</span>
        </div>
      </div>
    </section>
  );
};

export default DownloadSection;
